import { deleteAttachment } from "@portal/api/attachment";
import { notify } from "@portal/BaseComponents/Notifications";
import { useMutation } from "@tanstack/react-query";

export function useDeleteAttachmentQuery() {
  return useMutation({
    mutationKey: ["delete-attachment"],
    mutationFn: (id: number|string) => deleteAttachment(id),

    onError() {
      notify.error("Failed to delete attachment. Please try again later.");
    },
  });
}
